import { InteriorDeficiencyLayout } from './InteriorDeficiency.layout';
import { InteriorUpdateLayout } from './InteriorUpdate.layout';
import { RoomFeatureLayout } from './RoomFeature.layout';
import { PlumbingFixtureLayout } from './PlumbingFixture.layout';
import { CvKitchenEquipmentLayout } from './CvKitchenEquipment.layout';

export class RoomLayout {
	public fields = [
		{ fieldName: 'roomType' },
		{ fieldName: 'otherRoomTypeDescription' },
		{ fieldName: 'cv_interiorWallType' },
		{ fieldName: 'cv_interiorFloorType' }
	];

	public fieldsArray = [
		{
			fieldName: 'interiorDeficiencies',
			label: 'Interior Deficiencies',
			fields: new InteriorDeficiencyLayout().fields
		},
		{
			fieldName: 'interiorUpdates',
			label: 'Interior Updates',
			fields: new InteriorUpdateLayout().fields
		},
		{ fieldName: 'roomFeatures', label: 'Room Features', fields: new RoomFeatureLayout().fields },
		{
			fieldName: 'plumbingFixtures',
			label: 'Plumbing Fixtures',
			fields: new PlumbingFixtureLayout().fields
		},
		{
			fieldName: 'cv_kitchenEquipment',
			label: 'Kitchen Equipment',
			fields: new CvKitchenEquipmentLayout().fields
		}
	];
}
